<template>
  <el-card>
    <div>ID: {{ userInfo.id }}
      <CopyButton :text="userInfo.id" />
    </div>
    <el-collapse v-model="activeNames">
      <el-collapse-item title="基本信息" name="base">
        <el-form class="basic-part">
          <el-row>
            <el-col :span="8">Name: {{ userInfo.name }}
            </el-col>
            <el-col :span="8">First Name: {{ userInfo.first_name }}
            </el-col>
            <el-col :span="8">Last Name: {{ userInfo.last_name }}
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="8">用户等级(经验): {{ userInfo.level }} ({{ userInfo.exp }})</el-col>
            <el-col :span="8">
              当前剩余积分: {{ userInfo.point }}
              <el-link style="margin-left: 12px;" underline="always" type="primary" @click="showIncrementDialog">{{
                "增减"
              }}</el-link>
            </el-col>
            <el-col :span="8">总充值数: {{ userInfo.deposit }}</el-col>
          </el-row>
          <el-row>
            <el-col :span="8">邀请码: {{ userInfo.invitationCode }}
              <CopyButton :text="userInfo.invitationCode" />
            </el-col>
            <el-col :span="8">已邀请人数: {{ userInfo.invitationCount }}</el-col>
            <el-col :span="8">邀请人ID: <el-link underline="always" type="primary" @click="viewUser(userInfo.inviter)">{{
              userInfo.inviter
                }}</el-link></el-col>
          </el-row>
          <el-row>
            <el-col :span="12">注册时间: {{ $formatTime(userInfo.createdAt) }}</el-col>
          </el-row>
        </el-form>
      </el-collapse-item>
      <el-collapse-item title="用户地址" name="addresses">
        <el-table :data="addressesInfo.rows" v-loading="addressesInfo.loading" style="width: 100%">
          <el-table-column label="姓名" prop="name" width="160" />
          <el-table-column label="电话" prop="tel" width="150" />
          <el-table-column label="国家" prop="country" width="120" />
          <el-table-column label="省份" prop="province" width="120" />
          <el-table-column label="城市" prop="city" width="120" />
          <el-table-column label="邮编" prop="postalCode" width="80" />
          <el-table-column label="地址" prop="address" width="200" />
          <el-table-column label="标签" prop="tag" width="80" />
        </el-table>
      </el-collapse-item>

      <el-collapse-item title="抽卡记录" name="draws">
        <div class="table-wrapper">
          <el-table :data="drawLogsInfo.rows" v-loading="drawLogsInfo.loading" style="width: 100%">
            <el-table-column label="ID" prop="id" width="200" />
            <el-table-column label="卡包" prop="packName" width="200">
              <template #default="scope">
                <el-link underline="always" type="primary" @click="viewPack(scope.row.packId)">{{ scope.row.packName
                }}</el-link>
              </template>
            </el-table-column>
            <el-table-column label="抽卡次数" prop="count" width="120"></el-table-column>
            <el-table-column label="消费积分" prop="point" width="120">
              <template #default="scope">
                <el-text class="mx-1" type="danger">{{ scope.row.point }}</el-text>
              </template>
            </el-table-column>
            <el-table-column label="获得卡片" prop="cards" width="150">
              <template #default="scope">
                <div class="draw-images">
                  <div v-for="([id, count], index) in Object.entries(scope.row.cards)" :key="id"
                    class="draw-image-item">
                    <el-badge :value="count" type="primary" :offset="[-15, 10]">
                      <img :src="cardStore.cardsObj[id]?.image" loading="lazy" />
                    </el-badge>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="时间" prop="createdAt" width="200">
              <template #default="scope">
                {{ $formatTime(scope.row.createdAt) }}
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-wrapper">
          <el-pagination v-model:current-page="drawLogsInfo.page" v-model:page-size="drawLogsInfo.size"
            :page-sizes="[10, 20, 50]" :total="drawLogsInfo.total" layout="total, sizes, prev, pager, next, jumper"
            @current-change="loadDrawLogs" @size-change="loadDrawLogs" />
        </div>
      </el-collapse-item>
      <el-collapse-item title="积分兑换记录" name="exchange">
        <div class="table-wrapper">
          <el-table :data="exchangeLogsInfo.rows" v-loading="exchangeLogsInfo.loading" style="width: 100%">
            <el-table-column label="ID" prop="id" width="200" />
            <el-table-column label="获得积分" prop="point" width="120">
              <template #default="scope">
                <el-text class="mx-1" type="success">{{ scope.row.point }}</el-text>
              </template>
            </el-table-column>
            <el-table-column label="卡片" prop="cards" width="150">
              <template #default="scope">
                <div class="draw-images">
                  <div v-for="([id, count], index) in Object.entries(scope.row.cards)" :key="id"
                    class="draw-image-item">
                    <el-badge :value="count" type="primary" :offset="[-15, 10]">
                      <img :src="cardStore.cardsObj[id]?.image" loading="lazy" />
                    </el-badge>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="时间" prop="createdAt" width="200">
              <template #default="scope">
                {{ $formatTime(scope.row.createdAt) }}
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pagination-wrapper">
          <el-pagination v-model:current-page="exchangeLogsInfo.page" v-model:page-size="exchangeLogsInfo.size"
            :page-sizes="[10, 20, 50]" :total="exchangeLogsInfo.total" layout="total, sizes, prev, pager, next, jumper"
            @current-change="loadExchangeLogs" @size-change="loadExchangeLogs" />
        </div>
      </el-collapse-item>
      <el-collapse-item title="卡片提现记录" name="ships">
        <div class="table-wrapper">
          <el-table :data="shipLogsInfo.rows" v-loading="loading" style="width: 100%">
            <el-table-column label="ID" prop="id" width="200" />
            <el-table-column label="收件人" prop="name" width="150">
              <template #default="{ row }">
                <el-text class="mx-1">{{
                  `${row.address.name}`
                  }}</el-text>
              </template>
            </el-table-column>
            <el-table-column label="联系电话" prop="tel" width="160">
              <template #default="{ row }">
                <el-text class="mx-1">{{
                  `${row.address.tel}`
                  }}</el-text>
              </template>
            </el-table-column>
            <el-table-column label="地址" prop="address" width="300">
              <template #default="{ row }">
                <el-text class="mx-1">{{
                  `${row.address.country}-${row.address.province}-${row.address.city}-${row.address.address}`
                  }}</el-text>
              </template>
            </el-table-column>
            <el-table-column label="卡片" prop="cards" width="250">
              <template #default="scope">
                <div class="draw-images">
                  <div v-for="([id, count], index) in Object.entries(scope.row.cards)" :key="id"
                    class="draw-image-item">
                    <el-badge :value="count" type="primary" :offset="[-15, 10]">
                      <img :src="cardStore.cardsObj[id]?.image" loading="lazy" />
                    </el-badge>
                  </div>
                </div>
              </template>
            </el-table-column>
            <el-table-column label="物流公司" prop="deliveryCompany" width="200" />
            <el-table-column label="物流单号" prop="deliveryNumber" width="200" />
            <el-table-column label="状态" prop="status" width="120">
              <template #default="scope">
                <el-text v-if="scope.row.status === 0" class="mx-1" type="danger">待处理</el-text>
                <el-text v-else-if="scope.row.status === 1" class="mx-1" type="warning">处理中</el-text>
                <el-text v-else-if="scope.row.status === 2" class="mx-1" type="primary">已发货</el-text>
                <el-text v-else-if="scope.row.status === 3" class="mx-1" type="success">完成</el-text>
                <el-text v-else-if="scope.row.status === -1" class="mx-1" type="info">用户取消</el-text>
                <el-text v-else-if="scope.row.status === -2" class="mx-1" type="info">管理员取消</el-text>
              </template>
            </el-table-column>
            <el-table-column label="管理员备注" prop="adminRemark" width="200" />
            <el-table-column label="时间" prop="createdAt" width="200">
              <template #default="scope">
                {{ $formatTime(scope.row.createdAt) }}
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 分页 -->
        <div class="pagination-wrapper">
          <el-pagination v-model:current-page="shipLogsInfo.page" v-model:page-size="shipLogsInfo.size"
            :page-sizes="[10, 20, 50]" :total="shipLogsInfo.total" layout="total, sizes, prev, pager, next, jumper"
            @current-change="loadShipLogs" @size-change="loadShipLogs" />
        </div>
      </el-collapse-item>
      <el-collapse-item title="积分流水记录" name="points">
        <el-form :inline="true" class="filter-form">
          <el-form-item label="类型">
            <el-select v-model="pointLogsInfo.type" clearable style="width: 200px;">
              <el-option v-for="key in Object.keys(POINTLOG_TYPE)" :key="key" :label="POINTLOG_TYPE[key]"
                :value="key" />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="loadPointLogs">搜索</el-button>
          </el-form-item>
        </el-form>
        <div class="table-wrapper">
          <el-table :data="pointLogsInfo.rows" v-loading="pointLogsInfo.loading" style="width: 100%">
            <el-table-column label="ID" prop="id" width="200" />
            <el-table-column label="类型" prop="type" width="150">
              <template #default="scope">
                <el-text class="mx-1" type="primary">{{ POINTLOG_TYPE[scope.row.type] || scope.row.type }}</el-text>
              </template>
            </el-table-column>
            <el-table-column label="积分变化" prop="point" width="120">
              <template #default="scope">
                <el-text v-if="scope.row.point >= 0" class="mx-1" type="success">{{ scope.row.point }}</el-text>
                <el-text v-else class="mx-1" type="danger">{{ scope.row.point }}</el-text>
              </template>
            </el-table-column>
            <el-table-column label="时间" prop="createdAt" width="200">
              <template #default="scope">
                {{ $formatTime(scope.row.createdAt) }}
              </template>
            </el-table-column>
            <el-table-column label="操作ID" prop="handleId" width="200" />
          </el-table>
        </div>
        <div class="pagination-wrapper">
          <el-pagination v-model:current-page="pointLogsInfo.page" v-model:page-size="pointLogsInfo.size"
            :page-sizes="[10, 20, 50]" :total="pointLogsInfo.total" layout="total, sizes, prev, pager, next, jumper"
            @current-change="loadPointLogs" @size-change="loadPointLogs" />
        </div>
      </el-collapse-item>
    </el-collapse>
  </el-card>
  <el-dialog v-model="incrementPointParams.showDialog" title="增减积分" width="400px">
    <el-form :model="incrementPointParams" label-width="60px">
      <el-form-item label="提示:" prop="point">
        {{ "正数为给该用户增加积分，负数为扣除积分！" }}
      </el-form-item>
      <el-form-item label="积分" prop="point">
        <el-input-number v-model="incrementPointParams.point" />
      </el-form-item>
    </el-form>
    <template #footer>
      <el-button @click="incrementPointParams.showDialog = false">取消</el-button>
      <el-button :disabled="incrementPointParams.point === 0" v-loading="incrementPointParams.loading" type="primary"
        @click="addPoint">确定</el-button>
    </template>
  </el-dialog>
</template>

<script setup>
import { ref, reactive, watch, onMounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import { ElMessage } from 'element-plus';
import { apiCall } from "@/utils/api";
import { POINTLOG_TYPE } from "@/utils/constant";
import { useCardStore } from "@/stores/card/card";

const cardStore = useCardStore();

const route = useRoute();
const router = useRouter();

watch(
  () => route.path,
  () => {
    loadData();
  }
);

const loading = ref(false);

const activeNames = ref(['base']);

watch(
  () => activeNames,
  (newAns) => {
    const ans = newAns.value || [];
    if (ans.includes("addresses") && !addressesInfo.loaded) {
      loadAddresses();
    }
    if (ans.includes("points") && !pointLogsInfo.loaded) {
      loadPointLogs();
    }
    if (ans.includes("draws") && !drawLogsInfo.loaded) {
      loadDrawLogs();
    }
    if (ans.includes("exchange") && !exchangeLogsInfo.loaded) {
      loadExchangeLogs();
    }
    if (ans.includes("ships") && !shipLogsInfo.loaded) {
      loadShipLogs();
    }
  },
  { deep: true }
);

const userInfo = reactive({
  id: "",
  name: "",
  first_name: "",
  last_name: "",
  avatar: "",
  point: "",
  deposit: "",
  exp: 0,
  level: "",
  invitationCode: "",
  invitationCount: "",
  inviter: "",
  lockedAt: "",
  createdAt: "",
});

const incrementPointParams = reactive({
  loading: false,
  showDialog: false,
  point: 0,
});

function showIncrementDialog() {
  incrementPointParams.point = 0;
  incrementPointParams.showDialog = true;
}

function viewUser(id) {
  router.push(`/user/${id}`);
}

function viewPack(id) {
  router.push(`/pack/${id}`);
}

async function addPoint() {
  incrementPointParams.loading = true;

  const response = await apiCall("user.addPoints", {
    id: route.params.id,
    point: incrementPointParams.point,
  });
  incrementPointParams.loading = false;
  if (!response) {
    return false;
  }
  ElMessage.success("积分操作成功");
  incrementPointParams.showDialog = false;
  await loadData();
  if (pointLogsInfo.loaded) {
    await loadPointLogs();
  }
  return true;
}

async function loadData() {
  if (!route.params.id) {
    alert("empty id");
    return router.go(-1);
  }

  const { id } = route.params;

  loading.value = true;
  const response = await apiCall("user.getUserDetail", { id });
  if (!response) {
    loading.value = false;
    return false;
  }
  Object.keys(userInfo).forEach(key => {
    userInfo[key] = response[key];
  });

  loading.value = false;
}

const addressesInfo = reactive({
  loading: false,
  loaded: false,
  rows: [],
});

async function loadAddresses() {
  const { id } = route.params;

  addressesInfo.loading = true;
  const response = await apiCall("user.getUserAddresses", { userId: id });
  if (!response) {
    addressesInfo.loading = false;
    return false;
  }
  addressesInfo.rows = response;

  addressesInfo.loading = false;
  addressesInfo.loaded = true;
}

const pointLogsInfo = reactive({
  loading: false,
  loaded: false,
  rows: [],
  type: "",
  page: 1,
  size: 10,
  total: 0,
});

async function loadPointLogs() {
  const { id } = route.params;

  pointLogsInfo.loading = true;
  const params = {
    userId: id,
    page: pointLogsInfo.page,
    size: pointLogsInfo.size,
  };
  if (pointLogsInfo.type) {
    params.type = pointLogsInfo.type;
  }
  const response = await apiCall("user.getUserPointLogs", params);
  if (!response) {
    pointLogsInfo.loading = false;
    return false;
  }
  pointLogsInfo.rows = response.rows;
  pointLogsInfo.total = response.count;

  pointLogsInfo.loading = false;
  pointLogsInfo.loaded = true;
}

const drawLogsInfo = reactive({
  loading: false,
  loaded: false,
  rows: [],
  page: 1,
  size: 10,
  total: 0,
});

async function loadDrawLogs() {
  const { id } = route.params;

  drawLogsInfo.loading = true;
  const params = {
    userId: id,
    page: drawLogsInfo.page,
    size: drawLogsInfo.size,
  };

  const response = await apiCall("user.getUserDrawLogs", params);
  if (!response) {
    drawLogsInfo.loading = false;
    return false;
  }
  drawLogsInfo.rows = response.rows;
  drawLogsInfo.total = response.count;

  drawLogsInfo.loading = false;
  drawLogsInfo.loaded = true;
}

const shipLogsInfo = reactive({
  loading: false,
  loaded: false,
  rows: [],
  page: 1,
  size: 10,
  total: 0,
});

async function loadShipLogs() {
  const { id } = route.params;

  shipLogsInfo.loading = true;
  const params = {
    userId: id,
    page: shipLogsInfo.page,
    size: shipLogsInfo.size,
  };

  const response = await apiCall("user.getUserShipLogs", params);
  if (!response) {
    shipLogsInfo.loading = false;
    return false;
  }
  shipLogsInfo.rows = response.rows;
  shipLogsInfo.total = response.count;

  shipLogsInfo.loading = false;
  shipLogsInfo.loaded = true;
}

const exchangeLogsInfo = reactive({
  loading: false,
  loaded: false,
  rows: [],
  page: 1,
  size: 10,
  total: 0,
});

async function loadExchangeLogs() {
  const { id } = route.params;

  exchangeLogsInfo.loading = true;
  const params = {
    userId: id,
    page: exchangeLogsInfo.page,
    size: exchangeLogsInfo.size,
  };

  const response = await apiCall("user.getUserExchangeLogs", params);
  if (!response) {
    exchangeLogsInfo.loading = false;
    return false;
  }
  exchangeLogsInfo.rows = response.rows;
  exchangeLogsInfo.total = response.count;

  exchangeLogsInfo.loading = false;
  exchangeLogsInfo.loaded = true;
}

onMounted(async () => {
  await cardStore.getAll();
  await loadData();
});
</script>

<style scoped>
.basic-part .el-row {
  margin-bottom: 10px;
}

.draw-images {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(60px, 1fr));
  gap: 2px;
  padding: 2px;
}

.draw-image-item {
  position: relative;
  width: 60px;
  aspect-ratio: 3 / 4;
  overflow: hidden;
  border-radius: 8px;
  background: #f6f6f6;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.draw-image-item:hover {
  transform: scale(1.03);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.draw-image-item img {
  width: 60px;
  aspect-ratio: 3 / 4;
  object-fit: cover;
  cursor: pointer;
  transition: 0.3s ease;
}
</style>
